/* eslint-disable no-param-reassign */
import {
  UI_UPDATE_MASTER_DATA,
  UI_SET_LOADER,
  UI_UPDATE_TOWNS_BY_CP_CACHE,
  UI_SET_SHOWROOM_TYPE,
  UI_SET_PAGINATION_FILTER,
  UI_SET_OPERATIONS_FILTER,
  UI_SET_EXPIRATIONS_FILTER,
  UI_SET_COMMON_FILTER,
  UI_RESET_COMMONS_FILTERS,
  UI_SET_SECTION_FILTERS,
  UI_RESET_SECTION_FILTERS,
  UI_SET_SECTION_FILTERS_FIELDS,
  UI_SET_RESET_SECTION,
  UI_SET_CAMPAIGN_EDIT_FIELDS,
  UI_SET_SECTION_MENU,
  UI_SET_SECTION_MENU_ACTION,
  UI_SET_VEHICLE_MARKS,
  UI_SET_VEHICLE_MODELS,
  UI_SET_VEHICLE_STYLE_BODY,
  UI_RESET_VEHICLE_MODELS,
  UI_RESET_VEHICLE_BODY_STYLES,
  UI_SET_API_BUSY,
  UI_SET_LOADER_TEXT_MODAL,
  UI_SET_LOADER_MODAL,
  SET_UI,
  UI_SET_VEHICLE_LOCATION,
  UI_SET_VEHICLE_VERSION,
  UI_SET_VEHICLE_OPTIONS,
  SHOW_MAIN_NOTIFICATION,
  CLEAR_MAIN_NOTIFICATION,
  UI_SET_LIST_ID_OPTIONS
} from 'store/actions/ui';
import { mapArraryMasterData, setValueObjectByField } from 'helpers/object';
import {
  lsGetSelectedSectionFilters,
  lsSetSelectedSectionFilters,
  lsSetSelectedPaginationFilters,
  lsGetSelectedPaginationFilters,
  lsGetSelectedCommonFilters,
  lsSetSelectedCommonFilters,
  lsGetResetSection,
  lsSetResetSection
} from 'helpers/store';
import { MAIN_NOTIFICATION } from 'store/enums';

export default {
  [SET_UI]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },
  [UI_UPDATE_MASTER_DATA]: (state, data) => {
    const { streetType, maritalStatus, profession, sex, signType } = data;
    state.streetType = mapArraryMasterData(streetType);
    state.maritalStatus = mapArraryMasterData(maritalStatus);
    state.profession = mapArraryMasterData(profession);
    state.sex = mapArraryMasterData(sex);
    state.signType = mapArraryMasterData(signType);
  },

  [UI_SET_LOADER]: (state, loading) => {
    state.loader = loading;
  },

  [UI_SET_LOADER_MODAL]: (state, loading) => {
    state.loaderModal = loading;
  },

  [UI_SET_LOADER_TEXT_MODAL]: (state, text) => {
    state.loaderTextModal = text;
  },

  [UI_UPDATE_TOWNS_BY_CP_CACHE]: (state, { cp, towns }) => {
    state.townsCache[cp] = towns;
  },

  [UI_SET_SHOWROOM_TYPE]: (state, showRoomType) => {
    state.showRoomType = showRoomType;
  },

  [UI_SET_OPERATIONS_FILTER]: (state, { filter, value }) => {
    state.operationsFilters[filter] = value;
  },

  [UI_SET_EXPIRATIONS_FILTER]: (state, { filter, value }) => {
    state.expirationsFilters[filter] = value;
  },

  [UI_SET_COMMON_FILTER]: (state, { filter, value }) => {
    if (filter === 'partner') {
      const lsCommonFilters = lsGetSelectedCommonFilters() || {};
      lsCommonFilters.partner = value;
      lsSetSelectedCommonFilters(lsCommonFilters);
      state.commonFilters[filter] = value;
    } else {
      state.commonFilters[filter] = value;
    }
  },

  [UI_RESET_COMMONS_FILTERS]: state => {
    state.commonFilters.typeVehicle = 'TODOS';
    state.commonFilters.bodyStyle = null;
    state.commonFilters.rangePrice = ['<300', '>900'];
    state.commonFilters.filter = null;
  },

  [UI_SET_PAGINATION_FILTER]: (state, { entity, paginationFilters }) => {
    const lsPaginationFilters = lsGetSelectedPaginationFilters() || {};
    lsPaginationFilters[entity] = paginationFilters;
    lsSetSelectedPaginationFilters(lsPaginationFilters);
  },

  [UI_SET_SECTION_FILTERS]: (state, { sectionFilters, entity, sortDesc, perPage }) => {
    sectionFilters.grid.forEach(item => {
      item.key = item.field;
      delete item.field;
    });
    const lsSectionFilters = lsGetSelectedSectionFilters() || {};
    const lsPaginationFilters = lsGetSelectedPaginationFilters() || {};
    lsSectionFilters[entity] = sectionFilters;
    lsPaginationFilters[entity] = {
      currentPage: 1,
      perPage,
      sortBy: null,
      sortDesc,
      totalRows: null
    };
    lsSetSelectedSectionFilters(lsSectionFilters);
    lsSetSelectedPaginationFilters(lsPaginationFilters);
  },

  [UI_RESET_SECTION_FILTERS]: (
    state,
    { entity, perPage = 200, sortDesc = true, sortBy = null, totalRows = null }
  ) => {
    const lsSectionFilters = lsGetSelectedSectionFilters() || {};
    const lsPaginationFilters = lsGetSelectedPaginationFilters() || {};
    lsSectionFilters[entity] = null;
    lsPaginationFilters[entity] = {
      currentPage: 1,
      perPage,
      sortBy,
      sortDesc,
      totalRows
    };
    lsSetSelectedSectionFilters(lsSectionFilters);
    lsSetSelectedPaginationFilters(lsPaginationFilters);
  },

  [UI_SET_SECTION_FILTERS_FIELDS]: (state, { fields, entity }) => {
    const lsSectionFilters = lsGetSelectedSectionFilters() || {};
    lsSectionFilters[entity].fields = fields;
    lsSetSelectedSectionFilters(lsSectionFilters);
  },

  [UI_SET_RESET_SECTION]: (state, { entity, value }) => {
    const lsResetSection = lsGetResetSection() || {};
    lsResetSection[entity] = value;
    lsSetResetSection(lsResetSection);
  },

  [UI_SET_CAMPAIGN_EDIT_FIELDS]: (state, data) => {
    state.headersFields = data.header.fields;
    state.tabsFields = data.tabs;
  },

  [UI_SET_SECTION_MENU]: (state, items) => {
    state.sectionMenu = items;
  },

  [UI_SET_VEHICLE_MARKS]: (state, { property, brands, convert = true }) => {
    let brandOptions = [];
    if (!brands) {
      setValueObjectByField(state, property, brandOptions);
      return;
    }

    if (convert) {
      brandOptions = brands.map(brand => ({
        label: brand,
        value: encodeURIComponent(brand)
      }));
    } else {
      brandOptions = brands.map(brandObj => ({
        ...brandObj,
        value: encodeURIComponent(brandObj.value)
      }));
    }
    setValueObjectByField(state, property, brandOptions);
  },

  [UI_SET_VEHICLE_MODELS]: (state, { property, models, convert = true }) => {
    let modelOptions = [];
    if (!models) {
      setValueObjectByField(state, property, modelOptions);
      return;
    }
    if (convert) {
      modelOptions = models.map(model => ({
        label: model,
        value: encodeURIComponent(model)
      }));
    } else {
      modelOptions = models.map(modelObj => ({
        ...modelObj,
        value: encodeURIComponent(modelObj.value)
      }));
    }
    setValueObjectByField(state, property, modelOptions);
  },

  [UI_SET_VEHICLE_STYLE_BODY]: (state, { property, vehiclesType, convert = true }) => {
    if (!vehiclesType) {
      setValueObjectByField(state, property, []);
      return;
    }
    let styleBodyOptions = vehiclesType;
    if (convert) {
      styleBodyOptions = vehiclesType.map(brand => ({
        label: brand,
        value: brand
      }));
    }
    setValueObjectByField(state, property, styleBodyOptions);
  },

  [UI_SET_VEHICLE_LOCATION]: (state, { property, locations }) => {
    setValueObjectByField(state, property, locations || []);
  },

  [UI_SET_VEHICLE_VERSION]: (state, { property, versions }) => {
    setValueObjectByField(state, property, versions || []);
  },

  [UI_SET_VEHICLE_OPTIONS]: (state, { property, vehicle }) => {
    setValueObjectByField(state, property, vehicle || []);
  },

  [UI_SET_LIST_ID_OPTIONS]: (state, { property, idsVehicle }) => {
    const idVehicleOptions = idsVehicle?.map(idVehicle => ({
      label: idVehicle.toString(),
      value: idVehicle
    }));
    setValueObjectByField(state, property, idVehicleOptions || []);
  },

  [UI_SET_SECTION_MENU_ACTION]: (state, action) => {
    state.sectionMenuAction = { ...action };
  },

  [UI_RESET_VEHICLE_MODELS]: state => {
    state.models = [];
  },

  [UI_RESET_VEHICLE_BODY_STYLES]: state => {
    state.bodyStyles = [];
  },

  [UI_SET_API_BUSY]: (state, value) => {
    state.apiBusy = value;
  },

  [SHOW_MAIN_NOTIFICATION]: (state, payload) => {
    const updatedNotification = { ...state.mainNotification };
    Object.keys(payload).forEach(key => {
      updatedNotification[key] = payload[key];
    });
    updatedNotification.active = true;
    state.mainNotification = updatedNotification;
  },

  [CLEAR_MAIN_NOTIFICATION]: state => {
    state.mainNotification = { ...MAIN_NOTIFICATION };
  }
};
